import { __assign } from "tslib";
//Imports
import * as React from 'react';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
//Components
import { TimeToDisplayWrapper } from './WeeklyWrapper.styles';
import Calendar from '../Calendar/Calendar';
import WeeklyDesktopDatesHeader from '../../presentationals/WeeklyDesktopDatesHeader';
import WeeklyCalendarStyled from './WeeklyCalendarStyled';
import CalendarIconSvg from '../../../assets/CalendarIconSvg';
import { TextButton } from 'wix-ui-tpa';
//Enums
import Actions from '../../../enums/ActionsEnum';
import WeekStartersEnum from '../../../enums/WeekStartersEnum';
//Utils
import getCalendarsPopColors from '../../../utils/getCalendarsPopColors';
import getSpanPickerTimeFromStr from '../../../utils/getSpanPickerTimeFromStr';
import { dateToMomentWithFormat, getDatesEventsRange, shortMomentDate, } from '../../../utils/momentUtils';
import { st, classes } from './WeeklyCalendar.st.css';
import * as utils from '../Calendar/CalendarUtlis/CalendarUtils';
// Context
import WeeklyContext from '../../../context/weeklyContext';
import WixStylesContext from '../../../context/wixStylesContext';
import getCalendarPropsData from '../../../context/getCalendarPropsData';
import getWixStylesContextData from '../../../context/getWixStylesContextData';
import usePrevious from '../../../hooks/usePrevious';
var WeeklyCalendar = function (_a) {
    var calendarsProps = _a.calendarsProps;
    var dates = calendarsProps.dates, _b = calendarsProps.locale, locale = _b === void 0 ? 'en' : _b, _c = calendarsProps.action, action = _c === void 0 ? Actions.NO_ACTION : _c, _d = calendarsProps.timezone, timezone = _d === void 0 ? '' : _d, _e = calendarsProps.weekStarter, weekStarter = _e === void 0 ? WeekStartersEnum.Sunday : _e, handleMonthChange = calendarsProps.handleMonthChange, _f = calendarsProps.onTodayClick, onTodayClick = _f === void 0 ? null : _f, calendarRef = calendarsProps.calendarRef, wixStyles = calendarsProps.wixStyles, calendarsList = calendarsProps.calendarsList, isEditorX = calendarsProps.isEditorX;
    var t = useTranslation()[0];
    var calendar = React.useRef(null);
    var isCalendarsShown = typeof wixStyles.booleans.isCalendarsInfoShown === 'undefined'
        ? true
        : wixStyles.booleans.isCalendarsInfoShown;
    var isResponsive = typeof wixStyles.numbers.calendarHeightWeekly === 'undefined'
        ? false
        : wixStyles.numbers.calendarHeightWeekly === 1;
    var _g = React.useState({
        height: window.innerHeight,
        width: window.innerWidth,
    }), dimensions = _g[0], setDimensions = _g[1];
    var _h = React.useState(false), datePickerIsShown = _h[0], setDatePickerIsShown = _h[1];
    var _j = React.useState({
        shortDate: '',
        longDate: '',
        momentDate: moment(),
    }), date = _j[0], setDate = _j[1];
    React.useEffect(function () {
        var onResizeHandler = function () {
            setDimensions({
                height: window.innerHeight + 100,
                width: window.innerWidth,
            });
        };
        window.addEventListener('resize', onResizeHandler);
        return function () { return window.removeEventListener('resize', onResizeHandler); };
    }, []);
    React.useEffect(function () {
        var dateChangeCheck = function () {
            setInterval(function () {
                var loadDate = date.momentDate.format('YYYY-MM-DD');
                var currentDate = moment().format('YYYY-MM-DD');
                if (loadDate !== currentDate) {
                    setDate({
                        shortDate: shortMomentDate(moment(), locale),
                        //@ts-ignore
                        longDate: calendar.current.getApi().currentDataManager.data
                            .viewTitle,
                        momentDate: moment(),
                    });
                    // setLoadDate(currentDate);
                    location.reload(); // if state change doesnt halp - try location.reload();
                }
            }, 1000 * 60 * 60); // 3_600_000) // every hour check if date change
        };
        dateChangeCheck();
    }, [date.momentDate]);
    var prevLocale = usePrevious(locale);
    React.useEffect(function () {
        if (prevLocale !== locale) {
            setDate({
                shortDate: shortMomentDate(
                //@ts-ignore
                calendar.current.getApi().currentDataManager.data.currentDate, locale),
                //@ts-ignore
                longDate: calendar.current.getApi().currentDataManager.data.viewTitle,
                momentDate: moment(
                //@ts-ignore
                calendar.current.getApi().currentDataManager.data.currentDate),
            });
        }
    }, [locale]);
    React.useEffect(function () {
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            //@ts-ignore
            longDate: calendar.current.getApi().currentDataManager.data.viewTitle,
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    }, [weekStarter, wixStyles]);
    var todayClickedHandler = React.useCallback(function () {
        //@ts-ignore
        calendar.current.getApi().today();
        setDate({
            shortDate: shortMomentDate(moment(), locale),
            //@ts-ignore
            longDate: calendar.current.getApi().currentDataManager.data.viewTitle,
            momentDate: moment(),
        });
        onTodayClick();
    }, []);
    var handleMonthChangeWeekly = function () {
        var format = 'YYYY-MM-DD';
        var today = dateToMomentWithFormat(new Date(), format);
        //@ts-ignore
        var fCalendarWeekStartDate = calendar.current.getApi().currentDataManager
            .data.currentDate;
        var chosenDate = dateToMomentWithFormat(fCalendarWeekStartDate, format);
        var isFutureDay = chosenDate > today;
        var _a = utils.getStartAndEndMonthDates(fCalendarWeekStartDate), start = _a.start, end = _a.end;
        var _b = getDatesEventsRange(dates), eventsDateRangeStart = _b.eventsDateRangeStart, eventsDateRangeEnd = _b.eventsDateRangeEnd;
        var startInMoment = moment(start);
        var endInMoment = moment(end);
        if (eventsDateRangeEnd.diff(endInMoment, 'days') <= 7) {
            handleMonthChange(start, end, timezone, isFutureDay);
        }
        if (eventsDateRangeStart.diff(startInMoment, 'days') >= 7) {
            handleMonthChange(start, end, timezone, isFutureDay);
        }
    };
    var onPreviousClickedHandler = function () {
        //@ts-ignore
        calendar.current.getApi().prev();
        handleMonthChangeWeekly();
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            //@ts-ignore
            longDate: calendar.current.getApi().currentDataManager.data.viewTitle,
            //@ts-ignore
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    };
    var onNextClickedHandler = function () {
        //@ts-ignore
        calendar.current.getApi().next();
        handleMonthChangeWeekly();
        setDate({
            shortDate: shortMomentDate(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate, locale),
            //@ts-ignore
            longDate: calendar.current.getApi().currentDataManager.data.viewTitle,
            //@ts-ignore
            momentDate: moment(
            //@ts-ignore
            calendar.current.getApi().currentDataManager.data.currentDate),
        });
    };
    var Weekly = function () {
        var weekly = React.createElement(WeeklyCalendarStyled, null);
        var weeklyWithWrapper = (React.createElement("div", { className: classes.WeeklyWithWrapper, style: {
                height: "".concat(dimensions.height - 180, "px"),
            } }, weekly));
        var weeklyWithDatesHeader = (React.createElement(React.Fragment, null,
            React.createElement(WeeklyDesktopDatesHeader, null),
            isResponsive ? weeklyWithWrapper : weekly));
        return weeklyWithDatesHeader;
    };
    var isWeekFontMoreTwantyFive = typeof wixStyles !== 'undefined' &&
        typeof wixStyles.fonts.weekFont !== 'undefined' &&
        wixStyles.fonts.weekFont.size >= 25;
    var isWeekFontMax = typeof wixStyles !== 'undefined' &&
        typeof wixStyles.fonts.weekFont !== 'undefined' &&
        wixStyles.fonts.weekFont.size >= 25;
    var isCalendarsFontMax = typeof wixStyles !== 'undefined' &&
        typeof wixStyles.fonts.calendarsFont !== 'undefined' &&
        wixStyles.fonts.calendarsFont.size >= 25;
    var isHeaderFontMax = typeof wixStyles !== 'undefined' &&
        typeof wixStyles.fonts.headerFont !== 'undefined' &&
        wixStyles.fonts.headerFont.size >= 25;
    var smallSize = dimensions.width < 700 ||
        (dimensions.width < 800 &&
            isWeekFontMax &&
            isCalendarsFontMax &&
            isHeaderFontMax);
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            setDatePickerIsShown(!datePickerIsShown);
        }
    };
    var weekToDisplay = smallSize ? date.shortDate : date.longDate;
    var timeToDisplay = (React.createElement(TimeToDisplayWrapper, { tabIndex: 1, onClick: function () { return setDatePickerIsShown(!datePickerIsShown); }, onKeyDown: handleKeyDown, "aria-label": t('Google_Calendar_Date_Range', {
            dateRange: date.longDate,
        }) },
        React.createElement(TextButton, { className: st(classes.timeToDisplay, { isWeekFontMoreTwantyFive: isWeekFontMoreTwantyFive }), 
            // @ts-ignore
            priority: "secondary", suffixIcon: isWeekFontMoreTwantyFive && window.innerWidth < 700 ? ('') : (React.createElement(CalendarIconSvg, { ariaLabel: t('Google_Calendar_Date_Picker') })) }, getSpanPickerTimeFromStr(weekToDisplay))));
    return (React.createElement(WeeklyContext.Provider, { value: __assign(__assign({}, getCalendarPropsData(calendarsProps)), { calendarRef: calendar, setDatePickerIsShown: setDatePickerIsShown, datePickerIsShown: datePickerIsShown, rerenderTitleHandler: function () {
                return setDate({
                    shortDate: shortMomentDate(
                    //@ts-ignore
                    calendar.current.getApi().currentDataManager.data.currentDate, locale),
                    //@ts-ignore
                    longDate: calendar.current.getApi().currentDataManager.data
                        .viewTitle,
                    momentDate: moment(
                    //@ts-ignore
                    calendar.current.getApi().currentDataManager.data.currentDate),
                });
            }, date: date, 
            //@ts-ignore
            dateOnFocuse: date.momentDate }) },
        React.createElement(WixStylesContext.Provider, { value: __assign({}, getWixStylesContextData(wixStyles)) },
            React.createElement(Calendar, { isEditorX: isEditorX, locale: locale, isTimezoneShown: calendarsProps.isTimezoneShown, error: calendarsProps.error, calendarRef: calendarRef, dates: dates, handleMonthChange: handleMonthChange, handleSetHeight: calendarsProps.handleSetHeight, isTodayButtonStyleSecondary: calendarsProps.isTodayButtonStyleSecondary, handleTimezoneChange: calendarsProps.handleTimezoneChange, timezone: timezone, isMobile: calendarsProps.isMobile, action: action, isNextDisabled: calendarsProps.isNextDisabled, isPrevDisabled: calendarsProps.isPrevDisabled, openPopup: calendarsProps.openPopup, isLiveSite: calendarsProps.isLiveSite, onTodayClick: todayClickedHandler, handleCellSelect: calendarsProps.handleCellSelect, onPreviousClicked: onPreviousClickedHandler, onNextClicked: onNextClickedHandler, timeToDisplay: timeToDisplay, isWeekly: true, isCalendarsShown: isCalendarsShown, calendarsList: getCalendarsPopColors(wixStyles, calendarsList, dates), className: classes.CalendarExt, wixStyles: wixStyles }, Weekly))));
};
export default WeeklyCalendar;
//# sourceMappingURL=WeeklyCalendar.js.map